

import './bindings/dropdown'
import './bindings/input-plus-minus';

import './programme/coupon'
import './programme/totals'



$(document).ready(function() {

   $(".customInput").each(function() {
    $(this).removeAttr("disabled");
   });

   var pairs = [
       [1,7],
       [11,9],
      [17,15],
      [27,24],
      [29,28],
      [33,31],
      [35,34],
      [49,48],
      [50,51],
      [46,47,52]
   ];

   function findSibling(id,disable)
   {
      console.log(id);
      var i;
      var siblings = null;
      for (i = 0; i < pairs.length; i++) {

         var j;
         for(j=0;j<pairs[i].length;j++)
         {
            if(pairs[i][j] == id)
            {
               console.log("equal");
               siblings = pairs[i];
               break;
            }
         }
      }

      if (siblings) {
         for(i=0;i<siblings.length;i++)
         {
            if(siblings[i] != id && disable)
            {
               $("#two_"+siblings[i]).attr("disabled","disabled");
               $("#one_"+siblings[i]).attr("disabled","disabled");
               $("#elective_"+siblings[i]).attr("disabled","disabled");
            }

            if(siblings[i] != id && !disable)
            {
               $("#two_"+siblings[i]).removeAttr("disabled");
               $("#one_"+siblings[i]).removeAttr("disabled");
               $("#elective_"+siblings[i]).removeAttr("disabled");
            }
         }
      }
   }


   $(".customInput").click(function() {
      if(this.checked) {
         var id = this.id.split("_");
         findSibling(id[1],true);
      }
      else {
         var id = this.id.split("_");
         findSibling(id[1],false);
      }
   });


});